import { patch, get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useUpdateGeneralSetting = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("generalsetting", data);
    }, options);
};

export const useFetchGeneralSetting = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("generalsetting?settingCode=" + data.settingCode + "&countryId=" + data.countryId);
    }, options);
};

export const useUpdateGeneralSettingStatus = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("generalsetting/update/" , data);
    }, options);
};